import { render, staticRenderFns } from "./FormTemplatesFormCombobox.vue?vue&type=template&id=3bfaf2b0&"
import script from "./FormTemplatesFormCombobox.vue?vue&type=script&lang=js&"
export * from "./FormTemplatesFormCombobox.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplatesFormCombobox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VBtn,VChip,VCombobox,VIcon,VListItem,VSkeletonLoader,VSpacer})
